import React, { useEffect } from 'react';
import { PageTitle } from '../../layout/core';
import { NotificationItem } from '../../components/header/header-menus/NotificationItem';
import { fetchNotifications, useNotificationContext } from '../../store/notification-context';

export const Notifications = (): JSX.Element => {
	const { notificationContextState: { notificationsData }, dispatch } = useNotificationContext();

	useEffect(() => {
		fetchNotifications(dispatch);
	}, []);

	if (!notificationsData?.notifications || !notificationsData?.notifications?.length) {
		return (
			<div className="p-5 text-center fw-bolder">
				No Notifications
			</div>
		);
	}

	return (
		<>
			<PageTitle breadcrumbs={[]}>Notifications</PageTitle>
			<div className="card">
				<div className="card-body">
					<ul className="dropdown-menu-list m-0 p-5">
						{
							notificationsData?.notifications?.map((item) => (
								<NotificationItem
									{...item}
									key={item.id}
								/>
							))
						}
					</ul>
				</div>
			</div>
		</>
	);
};
